var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "c-facilities" }, [
    _c("h3", { staticClass: "c-facilities__header" }, [
      _vm._v("\n    Fasiliteter\n  "),
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "c-facilities__list" },
      _vm._l(_vm.facilities, function (facility) {
        return _c(
          "li",
          { key: facility.name, staticClass: "c-facilities__item" },
          [_vm._v("\n      " + _vm._s(facility.name) + "\n    ")]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }